import React, { } from "react";


// MUI (Material UI) components
import {
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";



export default function OverlayCard({ project }) {
    const theme = useTheme();
    if (!project) return null;
    return (
      <Card sx={{
        pointerEvents: "none",
        width: 420,
        maxWidth: "90vw",
        borderRadius: 3,
        boxShadow: 8,
        opacity: 0.95,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
      }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            {project.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {project.description}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {project.tags?.map((t) => (
              <Chip key={t} label={`#${t}`} size="small" color="primary" variant="outlined" />
            ))}
          </Stack>
        </CardContent>
      </Card>
    );
  }